import { TableCell, TableRow } from "flowbite-react";

export const ExpenseRowSkeleton = () => {
  return (
    <TableRow className="text-foreground">
      <TableCell>
        <div className="skeleton-base w-24 h-4" />
      </TableCell>
      <TableCell>
        <div className="skeleton-base w-36 h-4" />
      </TableCell>
      <TableCell>
        <div className="skeleton-base w-24 h-4" />
      </TableCell>
      <TableCell>
        <div className="skeleton-base w-36 h-4" />
      </TableCell>
    </TableRow>
  );
};
